import actionSaga from './activity/saga';
import userSaga from './user/saga';
import stationSaga from './stations/saga';


const sagas = [actionSaga, userSaga, stationSaga];

export default sagas;